export interface DurationMembers {
  days: number;
  hours: number;
  minutes: number;
}

export class MultiFieldDurationPickerHelper {
  public static createDurationMembers(totalMinutes: number): DurationMembers {
    if (totalMinutes == null) {
      return {days: null, hours: null, minutes: null};
    }
    const days = Math.floor(totalMinutes / (24 * 60));
    const leftMinutes = (totalMinutes % (24 * 60));
    const hours = Math.floor(leftMinutes / 60);
    const minutes = leftMinutes % 60;
    return {days, hours, minutes};
  }

  public static calculateTotalMinutes(days: number, hours: number, minutes: number, setZeroAsNull: boolean) {
    const totalMinutes = ((days ?? 0) * 24 + (hours ?? 0)) * 60 + (minutes ?? 0);
    if (!totalMinutes && setZeroAsNull) {
      return null;
    }
    return totalMinutes;
  }
}
